/** Sdilene vycty a konstanty hubu. Identifikatory anglicky, texty administrace cesky. */
import { z } from 'zod';
import { DEPARTMENTS } from './departments.js';
export const SEND_MODES = ['dry_run', 'test_allowlist', 'live'];
/** Poradi od nejbezpecnejsiho. SEND_MODE z prostredi je horni mez (DECISIONS D-18). */
export const SEND_MODE_RANK = {
    dry_run: 0,
    test_allowlist: 1,
    live: 2,
};
export const APP_ENVS = ['development', 'test', 'production'];
/** Prostředí, mezi kterými administrace přepíná (D-132). Pořadí = od nejbezpečnějšího. */
export const HUB_ENVIRONMENTS = ['development', 'staging', 'production'];
export const HUB_ROLES = ['api', 'worker'];
export const CLOCK_MODES = ['system', 'simulated'];
/** Zpětně kompatibilní názvy: role jsou oddělení (D-103). */
export const USER_ROLES = DEPARTMENTS;
/** Tvar kódu značky. Jestli značka existuje, ověřuje hub za běhu proti tabulce `brands`. */
export const BRAND_CODE_PATTERN = /^[A-Z][A-Z0-9_]{1,15}$/;
export const brandCodeSchema = z
    .string()
    .regex(BRAND_CODE_PATTERN, 'Kód značky: velká písmena a číslice, 2 až 16 znaků.');
export const BRAND_KINDS = ['shop', 'media'];
/** Zdroje jazyka kontaktu od nejlepšího (D-92). */
export const LANGUAGE_SOURCES = [
    'profile',
    'order',
    'legacy',
    'browser',
    'accept_language',
    'country_default',
    'brand_default',
];
/** Zdroje časového pásma od nejlepšího. */
export const TIMEZONE_SOURCES = [
    'profile',
    'browser',
    'legacy',
    'phone',
    'country',
    'brand_default',
];
//# sourceMappingURL=enums.js.map